import type { ReactNode } from 'react';
import React from 'react';

import { BannerContext } from '@confluence/banners/entry-points/BannerContext.ts';

type EmbeddedWhiteboardRouteWrapperProps = {
	children: ReactNode;
};

const bannerContextValue = { includeTopNav: false };

export const EmbeddedWhiteboardRouteWrapper = ({
	children,
}: EmbeddedWhiteboardRouteWrapperProps) => (
	<BannerContext.Provider value={bannerContextValue}>{children}</BannerContext.Provider>
);
